
import * as _ from "lodash"
import {
  IMetricsSet,
  IMetrics,
  IMetricParameters,
  IMetricParameterSet,
  IMetricDetailsSet,
  IMetricDetails, IMetricDetailRow, Metric_All_Additive_Fields
} from './PA.Metrics.IF'
import {DateUtils} from "../PA.Core/Basic/Dates";
import { IVolumeAlignment } from "../PA.TPM.Services/VolumeAlignmentUtils"


//<editor-fold desc="Metric Additive Fields">

const metricAdditiveFields = Metric_All_Additive_Fields
// </editor-fold>

export class Metrics implements IMetrics {

  IntersectionMetrics: IMetrics = undefined;
  CalcError: any = undefined;


  //<editor-fold desc="Metric Fields">

  CNSMP_BASE_UNITS: number = 0;
  CNSMP_BASE_WT: number = 0;
  CNSMP_BASE_STAT: number = 0;
  CNSMP_BASE_LISTSLS: number = 0;
  CNSMP_BASE_NETLISTSLS: number = 0;
  CNSMP_BASE_RTLSLS: number = 0;
  CNSMP_BASE_PRFTCNTRB: number = 0;
  CNSMP_EDLP_UNITS: number = 0;
  CNSMP_EDLP_WT: number = 0;
  CNSMP_EDLP_STAT: number = 0;
  CNSMP_EDLP_LISTSLS: number = 0;
  CNSMP_EDLP_NETLISTSLS: number = 0;
  CNSMP_EDLP_RTLSLS: number = 0;
  CNSMP_EDLP_PRFTCNTRB: number = 0;
  CNSMP_INCR_UNITS: number = 0;
  CNSMP_INCR_WT: number = 0;
  CNSMP_INCR_STAT: number = 0;
  CNSMP_INCR_LISTSLS: number = 0;
  CNSMP_INCR_NETLISTSLS: number = 0;
  CNSMP_INCR_RTLSLS: number = 0;
  CNSMP_INCR_PRFTCNTRB: number = 0;
  CNSMP_DISP_INCR_UNITS: number = 0;
  CNSMP_DISP_INCR_WT: number = 0;
  CNSMP_DISP_INCR_STAT: number = 0;
  CNSMP_DISP_INCR_LISTSLS: number = 0;
  CNSMP_DISP_INCR_NETLISTSLS: number = 0;
  CNSMP_DISP_INCR_RTLSLS: number = 0;
  CNSMP_DISP_INCR_PRFTCNTRB: number = 0;
  CNSMP_TOTAL_UNITS: number = 0;
  CNSMP_TOTAL_WT: number = 0;
  CNSMP_TOTAL_STAT: number = 0;
  CNSMP_TOTAL_LISTSLS: number = 0;
  CNSMP_TOTAL_NETLISTSLS: number = 0;
  CNSMP_TOTAL_RTLSLS: number = 0;
  CNSMP_TOTAL_PRFTCNTRB: number = 0;
  CNSMP_PROMO_UNITS: number = 0;
  CNSMP_PROMO_WT: number = 0;
  CNSMP_PROMO_STAT: number = 0;
  CNSMP_PROMO_LISTSLS: number = 0;
  CNSMP_PROMO_NETLISTSLS: number = 0;
  CNSMP_PROMO_RTLSLS: number = 0;
  CNSMP_PROMO_PRFTCNTRB: number = 0;
  CNSMP_NONPROMO_UNITS: number = 0;
  CNSMP_NONPROMO_WT: number = 0;
  CNSMP_NONPROMO_STAT: number = 0;
  CNSMP_NONPROMO_LISTSLS: number = 0;
  CNSMP_NONPROMO_NETLISTSLS: number = 0;
  CNSMP_NONPROMO_RTLSLS: number = 0;
  CNSMP_NONPROMO_PRFTCNTRB: number = 0;
  MERCH_FEATUREONLY_ACV_N: number = 0;
  MERCH_DISPLAYONLY_ACV_N: number = 0;
  MERCH_FEATUREDISPLAY_ACV_N: number = 0;
  MERCH_TPRONLY_ACV_N: number = 0;
  MERCH_PROMOTED_ACV_N: number = 0;
  MERCH_DIST_ACV_N: number = 0;
  MERCH_ACV_D: number = 0;
  MERCH_FEATUREONLY_UNITS: number = 0;
  MERCH_DISPLAYONLY_UNITS: number = 0;
  MERCH_FEATUREDISPLAY_UNITS: number = 0;
  MERCH_TPRONLY_UNITS: number = 0;
  MERCH_PROMOTED_UNITS: number = 0;
  SHIPMENT_ORDER_QTY: number = 0;
  SHIPMENT_BUOM_QTY: number = 0;
  SHIPMENT_UNITS: number = 0;
  SHIPMENT_WT: number = 0;
  SHIPMENT_STAT: number = 0;
  SHIPMENT_LISTSLS: number = 0;
  SHIPMENT_NETLISTSLS: number = 0;
  SHIPMENT_PRFTCNTRB: number = 0;
  RETURN_ORDER_QTY: number = 0;
  RETURN_BUOM_QTY: number = 0;
  RETURN_UNITS: number = 0;
  RETURN_WT: number = 0;
  RETURN_STAT: number = 0;
  RETURN_LISTSLS: number = 0;
  RETURN_NETLISTSLS: number = 0;
  RETURN_PRFTCNTRB: number = 0;

  [id: string]: any
  //</editor-fold>

  //<editor-fold desc="Constructor and JSON parsing">

  constructor() {

  }

  static parseJSON(srcObject: any) : Metrics {
    const metrics = new Metrics();

    for(const key in metrics) {
      // If the value exists in the target, copy it..
      const bKeyExists = (key in srcObject)
      if(bKeyExists) {
        const srcValue = srcObject[key]
        switch(key) {
          case 'IntersectionMetrics':
            if(!_.isUndefined(srcValue)){
              metrics.IntersectionMetrics = Metrics.parseJSON(srcValue)
            }
            break;

          case 'CalcError': // boolean
            metrics[key] = srcValue
            break;

          default: // number
            metrics[key] = Number(srcValue)
            break;
        }
      }
    }
    return metrics;
  }
  //</editor-fold>

  //<editor-fold desc="Calculated Compound Metrics">


  set LIST_PRICE(value) {}
  get LIST_PRICE(): number {
    if((this.SHIPMENT_NETLISTSLS > 0) && (this.SHIPMENT_UNITS > 0)) {
      return this.SHIPMENT_NETLISTSLS / this.SHIPMENT_UNITS
    }

    if((this.CNSMP_TOTAL_NETLISTSLS > 0) && (this.CNSMP_TOTAL_UNITS > 0)) {
      return this.CNSMP_TOTAL_NETLISTSLS / this.CNSMP_TOTAL_UNITS
    }
    return 0
  }

  set LIFT_BYUNITS_PCNT(value) { }
  get LIFT_BYUNITS_PCNT(): number {
    if ((this.CNSMP_BASE_UNITS + this.CNSMP_EDLP_UNITS) > 0) {
      return this.CNSMP_INCR_UNITS / (this.CNSMP_BASE_UNITS + this.CNSMP_EDLP_UNITS)
    }
    return 0
  }

  set LIFT_BYWT_PCNT(value) { }
  get LIFT_BYWT_PCNT(): number {
    if ((this.CNSMP_BASE_WT + this.CNSMP_EDLP_WT) > 0) {
      return this.CNSMP_INCR_WT / (this.CNSMP_BASE_WT + this.CNSMP_EDLP_WT)
    }
    return 0
  }

  set VCM_CNSMP_INCR_PCNT(value) { }
  get VCM_CNSMP_INCR_PCNT(): number {
    if(this.CNSMP_INCR_NETLISTSLS > 0) {
      return this.CNSMP_INCR_PRFTCNTRB / this.CNSMP_INCR_NETLISTSLS
    }
    return 0
  }

  set VCM_CNSMP_PCNT(value) { }
  get VCM_CNSMP_PCNT(): number {
    if(this.CNSMP_TOTAL_NETLISTSLS > 0) {
      return this.CNSMP_TOTAL_PRFTCNTRB / this.CNSMP_TOTAL_NETLISTSLS
    }
    return 0
  }

  set VCM_SHIP_PCNT(value) { }
  get VCM_SHIP_PCNT(): number {
    if(this.SHIPMENT_NETLISTSLS > 0) {
      return this.SHIPMENT_PRFTCNTRB / this.SHIPMENT_NETLISTSLS
    }
  return 0
  }

  set RETAILER_BASE_PRICE(value) { }
  get RETAILER_BASE_PRICE(): number {
    if (this.CNSMP_BASE_UNITS > 0) {
      return this.CNSMP_BASE_RTLSLS / this.CNSMP_BASE_UNITS
    }
    return this.RETAILER_AVG_PRICE
  }

  set RETAILER_PROMOTED_PRICE(value) { }
  get RETAILER_PROMOTED_PRICE(): number {
    if (this.CNSMP_PROMO_UNITS > 0) {
      return this.CNSMP_PROMO_RTLSLS / this.CNSMP_PROMO_UNITS
    }
    return this.RETAILER_AVG_PRICE
  }

  set RETAILER_AVG_PRICE(value) {}
  get RETAILER_AVG_PRICE(): number {
    if(this.CNSMP_TOTAL_UNITS > 0) {
      return this.CNSMP_TOTAL_RTLSLS / this.CNSMP_TOTAL_UNITS
    }
    return 0
  }

  set MERCH_FEATUREONLY_ACV_PCNT(value) { }
  get MERCH_FEATUREONLY_ACV_PCNT(): number {
    if(this.MERCH_ACV_D > 0) {
      return this.MERCH_FEATUREONLY_ACV_N / this.MERCH_ACV_D
    }
    return 0
  }

  set MERCH_DISPLAYONLY_ACV_PCNT(value) { }
  get MERCH_DISPLAYONLY_ACV_PCNT(): number {
    if(this.MERCH_ACV_D > 0) {
      return this.MERCH_DISPLAYONLY_ACV_N / this.MERCH_ACV_D
    }
    return 0
  }

  set MERCH_FEATUREDISPLAY_ACV_PCNT(value) { }
  get MERCH_FEATUREDISPLAY_ACV_PCNT(): number {
    if(this.MERCH_ACV_D > 0) {
      return this.MERCH_FEATUREDISPLAY_ACV_N / this.MERCH_ACV_D
    }
    return 0
  }

  set MERCH_TPRONLY_ACV_PCNT(value) {}
  get MERCH_TPRONLY_ACV_PCNT(): number {
    if(this.MERCH_ACV_D > 0) {
      return this.MERCH_TPRONLY_ACV_N / this.MERCH_ACV_D
    }
    return 0
  }

  set MERCH_PROMOTED_ACV_PCNT(value) { }
  get MERCH_PROMOTED_ACV_PCNT(): number {
    if(this.MERCH_ACV_D > 0) {
      return this.MERCH_PROMOTED_ACV_N / this.MERCH_ACV_D
    }
    return 0
  }

  set MERCH_DIST_ACV_PCNT(value) {}
  get MERCH_DIST_ACV_PCNT(): number {
    if(this.MERCH_ACV_D > 0) {
      return this.MERCH_DIST_ACV_N / this.MERCH_ACV_D
    }
    return 0
  }

    set CNSMP_SYND_BASE_UNITS(value) {}
    get CNSMP_SYND_BASE_UNITS(): number {
        return this.CNSMP_BASE_UNITS + this.CNSMP_EDLP_UNITS
    }

    set CNSMP_SYND_BASE_RTLSLS(value) {}
    get CNSMP_SYND_BASE_RTLSLS(): number {
      return this.CNSMP_BASE_RTLSLS + this.CNSMP_EDLP_RTLSLS
    }

    set CNSMP_SYND_BASE_STAT(value) {}
    get CNSMP_SYND_BASE_STAT(): number {
      return this.CNSMP_BASE_STAT + this.CNSMP_EDLP_STAT
    }

    set CNSMP_SYND_BASE_WT(value) {}
    get CNSMP_SYND_BASE_WT(): number {
      return this.CNSMP_BASE_WT + this.CNSMP_EDLP_WT
    }

    set CNSMP_SYND_BASE_LISTSLS(value) {}
    get CNSMP_SYND_BASE_LISTSLS(): number {
      return this.CNSMP_BASE_LISTSLS + this.CNSMP_EDLP_LISTSLS
    }

    set CNSMP_SYND_BASE_NETLISTSLS(value) {}
    get CNSMP_SYND_BASE_NETLISTSLS(): number {
      return this.CNSMP_BASE_NETLISTSLS + this.CNSMP_EDLP_NETLISTSLS
    }

    set CNSMP_SYND_BASE_PRFTCNTRB(value) {}
    get CNSMP_SYND_BASE_PRFTCNTRB(): number {
      return this.CNSMP_BASE_PRFTCNTRB + this.CNSMP_EDLP_PRFTCNTRB
    }



//</editor-fold>

  //<editor-fold desc="Metric Arithmetic">

  clone(): IMetrics {
    var rv = new Metrics()
    rv.CalcError = this.CalcError
    _.forEach(metricAdditiveFields, (aFieldName) => {
      rv[aFieldName] = this[aFieldName]
    })

    if (!_.isUndefined(this.IntersectionMetrics)) {
      rv.IntersectionMetrics = this.IntersectionMetrics.clone()
    }
    return rv
  }

  add(b: IMetrics, mtrFields?: string[], bExcludeIntersect?: boolean){
    _.forEach(_.isArray(mtrFields)?mtrFields:metricAdditiveFields, (aFieldName) => {
      this[aFieldName] += b[aFieldName]
    })

    if(bExcludeIntersect)
      return

    if ((!_.isUndefined(this.IntersectionMetrics)) &&
        (!_.isUndefined(b.IntersectionMetrics))) {
         this.IntersectionMetrics.add(b.IntersectionMetrics, mtrFields)
    }
  }

  subtract(b:IMetrics, mtrFields?: string[], bExcludeIntersect?: boolean){
    _.forEach(_.isArray(mtrFields)?mtrFields:metricAdditiveFields, (aFieldName) => {
      this[aFieldName] -= b[aFieldName]
    })

    if(bExcludeIntersect)
      return

    if ((!_.isUndefined(this.IntersectionMetrics)) &&
      (!_.isUndefined(b.IntersectionMetrics))) {
      this.IntersectionMetrics.subtract(b.IntersectionMetrics, mtrFields)
    }
  }

  scaleBy(aScaleFactor: number): void {
    _.forEach(metricAdditiveFields, (aFieldName) => {
      this[aFieldName] *= aScaleFactor
    })
    if (!_.isUndefined(this.IntersectionMetrics)) {
      this.IntersectionMetrics.scaleBy(aScaleFactor)
    }
  }

  //</editor-fold>

}

export class MetricsSet implements IMetricsSet {
  [id: string] : IMetrics

  static parseJSON(srcObject: any) : MetricsSet {
    let metricsSet = new MetricsSet();

    for (var key in srcObject) {
      let srcValue = srcObject[key]
      if (!_.isUndefined(srcValue)) {
        metricsSet[key] = Metrics.parseJSON(srcValue)
      }
    }
    return metricsSet
  }

}

export class MetricDetailRow implements IMetricDetailRow {
  Key: string = undefined;

  PlanningCustomer: number   = undefined;
  SourceCustomer: number     = undefined;
  Product: number            = undefined;
  ConsumerProductUPC: string = undefined;
  Source: number             = undefined;
  Date: Date                 = undefined;

  Metrics: IMetrics = undefined;

  [id: string] : any

  static parseJSON(srcObject: any): MetricDetailRow {

    let metricDetailRow = new MetricDetailRow()

    for(var key in metricDetailRow) {
      // If the value exists in the target, copy it..
      var bKeyExists = (key in srcObject)
      if(bKeyExists) {
        var srcValue = srcObject[key]

        switch(key) {
          // Dates have to be converted from strings.. Arrays, Strings & booleans convert ok.
          case 'Date':
            if(!_.isUndefined(srcValue)){
              metricDetailRow[key] = new Date(srcValue)
            }
            break;

          case 'Metrics':
            metricDetailRow.Metrics = Metrics.parseJSON(srcValue)
            break;

          default:
            metricDetailRow[key] = srcValue
            break;
        }
      }
    }
    return metricDetailRow;

  }

}

export class MetricDetails implements  IMetricDetails {
  [id: string]: any;

  CalcError: any = ''
  DetailRows: IMetricDetailRow[] = []


  static parseJSON(srcObject: any): MetricDetails {
    let metricDetails = new MetricDetails()

    for(var key in metricDetails) {
      // If the value exists in the target, copy it..
      var bKeyExists = (key in srcObject)
      if(bKeyExists) {
        var srcValue = srcObject[key]

        switch(key) {
          // Dates have to be converted from strings.. Arrays, Strings & booleans convert ok.
          case 'NoDateFields':
            if(!_.isUndefined(srcValue)){
              metricDetails[key] = new Date(srcValue)
            }
            break;

          case 'DetailRows':
            if(_.isArray(srcValue) && !_.isEmpty(srcValue)){
              metricDetails.DetailRows = _.map(srcValue, (sObject) => { return MetricDetailRow.parseJSON(sObject)})
            }
            break;

          default:
            metricDetails[key] = srcValue
            break;
        }
      }
    }

    return metricDetails
  }

}


export class MetricDetailsSet implements IMetricDetailsSet {
  [id: string]: IMetricDetails;


  static parseJSON(srcObject: any): MetricDetailsSet {
    let metricDetailsSet = new MetricDetailsSet();

    for (var key in srcObject) {
      var srcValue = srcObject[key]
      if (!_.isUndefined(srcValue)) {
        metricDetailsSet[key] = MetricDetails.parseJSON(srcValue)
      }
    }
    return metricDetailsSet
  }
}

export class MetricParameters
    implements
        IMetricParameters
{
  MetricParameterId: string = 'NA';
  Sources: number[] = [];
  PlanningCustomers: number[] = [];
  SourceCustomers: number[] = [];
  FinishedProducts: number[] = [];
  OrderFinishedProduct: number[] = [];
  ConsumerProductUPCs: string[] = [];
  SalesArea: number[] = [];
  SalesOrg: number[] = [];
  ProductGroups: number[] = [];
  ConsumptionAdjustmentsPGs: number[] = [];
  InStoreStartDt: Date = undefined;
  InStoreEndDt: Date = undefined;
  ShipmentStartDt: Date = undefined;
  ShipmentEndDt: Date = undefined;
  bIncludeAdjustments: boolean = true;
  bIncludeEDLPSplit: boolean = true
  bCalculateIntersection: boolean = false;
  Int_InStoreStartDt: Date = undefined;
  Int_InStoreEndDt: Date = undefined;
  Int_ShipmentStartDt: Date = undefined;
  Int_ShipmentEndDt: Date = undefined;
  Int_VolumeAlignment: IVolumeAlignment = undefined;
  VolumeAlignment: IVolumeAlignment = undefined;
  [id: string] : any

  static parseJSON(srcObject: any) : MetricParameters {
    const metricParameters = new MetricParameters();

    for(let key in metricParameters) {
      // If the value exists in the target, copy it..
      const bKeyExists = (key in srcObject)
      if(bKeyExists) {
        let srcValue = srcObject[key]

        switch(key) {
          // Dates have to be converted from strings.. Arrays, Strings & booleans convert ok.
          case 'InStoreStartDt':
          case 'InStoreEndDt':
          case 'ShipmentStartDt':
          case 'ShipmentEndDt':
          case 'Int_InStoreStartDt':
          case 'Int_InStoreEndDt':
          case 'Int_ShipmentStartDt':
          case 'Int_ShipmentEndDt':
            if(!_.isDate(srcValue)){
              metricParameters[key] = DateUtils.convertFromSAPBW(srcValue)
            }
            break;

          default:
            metricParameters[key] = srcValue
            break;
        }
      }
    }
    return metricParameters;
  }

  toJSON() {
    const returnValue: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (_.isDate(value)) {
        returnValue[key] = DateUtils.convertToSAPBW(value);
      } else {
        returnValue[key] = value;
      }
    }
    return returnValue;
  }
}

export class MetricsParameterSet implements IMetricParameterSet {
  [id: string] : IMetricParameters

  static parseJSON(srcObject: any) : MetricsParameterSet {
    const parameterSet = new MetricsParameterSet();

    for (let key in srcObject) {
      let srcValue = srcObject[key]
      if (!_.isUndefined(srcValue)) {
        parameterSet[key] = MetricParameters.parseJSON(srcValue)
      }
    }
    return parameterSet
  }

}
